exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sk-wave {\r\n    position: relative;\r\n    top: 50%;\r\n    margin: auto;\r\n    width: 50px;\r\n    height: 40px;\r\n    text-align: center;\r\n    font-size: 10px;\r\n}\r\n\r\n.sk-wave .sk-rect {\r\n    height: 100%;\r\n    width: 6px;\r\n    display: inline-block;\r\n    animation: sk-waveStretchDelay 1.2s infinite ease-in-out;\r\n}\r\n\r\n.sk-wave .sk-rect1 {\r\n    animation-delay: -1.2s;\r\n}\r\n\r\n.sk-wave .sk-rect2 {\r\n    animation-delay: -1.1s;\r\n}\r\n\r\n.sk-wave .sk-rect3 {\r\n    animation-delay: -1s;\r\n}\r\n\r\n.sk-wave .sk-rect5 {\r\n    animation-delay: -0.8s;\r\n}\r\n\r\n.sk-wave .sk-rect4 {\r\n    animation-delay: -0.9s;\r\n}\r\n\r\n@keyframes sk-waveStretchDelay {\r\n    0%, 40%, 100% {\r\n        transform: scaleY(0.4);\r\n    }\r\n    20% {\r\n        transform: scaleY(1);\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Empower360Plus/EmpowerWeb2.0/A4.Empower/A4.Empower/ClientApp/src/app/shared/spinner/spinkit-css/sk-wave.css
// module id = ../../../../../src/app/shared/spinner/spinkit-css/sk-wave.css
// module chunks = main